import { render, staticRenderFns } from "./defaultacc.vue?vue&type=template&id=6f00edd9&"
import script from "./defaultacc.vue?vue&type=script&lang=js&"
export * from "./defaultacc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports